import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

const StyledModalHeader = styled(Modal.Header)`
  background: ${(props) => props.background || props.theme.colors.dark};
  height: 322px;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  position: relative;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export default StyledModalHeader;
